import { fhirDateTime } from '../Date/Format/index.js'

import { transform } from './mapper.js'

const primaryDiagnosisExtension = {
  url: 'http://narushealth.com/fhir/StructureDefinition/primaryDiagnosis'
}

const treatingPhysicianExtension = {
  url: 'http://narushealth.com/fhir/StructureDefinition/treatingPhysician'
}

const onsetMonthExtension = {
  url: 'http://compassion.narushealth.com/fhir/StructureDefinition/condition-onsetMonth'
}

const onsetYearExtension = {
  url: 'http://compassion.narushealth.com/fhir/StructureDefinition/condition-onsetYear'
}

const discussedWithPatientExtension = {
  url: 'http://compassion.narushealth.com/fhir/StructureDefinition/discussedWithPatient'
}

const categoryExtension = {
  url: 'http://narushealth.com/fhir/StructureDefinition/ConditionCategory'
}

const chapterExtension = {
  url: 'http://narushealth.com/fhir/StructureDefinition/ConditionChapter'
}

const mapping = [
  {
    fhir: [ 'resourceType' ],
    fhir_const: 'Condition'
  },
  {
    fhir: [ 'contained', { resourceType: 'QuestionnaireResponse' }, 'status' ],
    fhir_const: 'in-progress'
  },
  {
    fhir: [ 'id' ],
    form: [ 'id' ]
  },
  {
    fhir: [ 'code', 'coding', 0, 'code' ],
    form: [ 'name', 'code' ]
  },
  {
    fhir: [ 'code', 'coding', 0, 'display' ],
    form: [ 'name', 'display' ]
  },
  {
    fhir: [ 'code', 'coding', 0, 'system' ],
    form: [ 'name', 'system' ]
  },
  {
    fhir: [ 'category' ],
    fhir_const: {
      coding: [
        {
          system: 'http://hl7.org/fhir/condition-category',
          code: 'diagnosis',
          display: 'Diagnosis'
        }
      ]
    }
  },
  {
    fhir: [ 'clinicalStatus' ],
    fhir_const: 'active'
  },
  {
    fhir: [ 'verificationStatus' ],
    fhir_const: 'confirmed'
  },
  {
    fhir: [ 'severity', 'text' ],
    form: [ 'severity' ]
  },
  {
    fhir: [ 'extension', onsetMonthExtension, 'valueString' ],
    form: [ 'onsetMonth' ]
  },
  {
    fhir: [ 'extension', onsetYearExtension, 'valueString' ],
    form: [ 'onsetYear' ]
  },
  {
    fhir: [ 'extension', discussedWithPatientExtension, 'valueBoolean' ],
    form: [ 'discussedWithPatient' ]
  },
  {
    fhir: [ 'extension', categoryExtension, 'valueString' ],
    form: [ 'category' ]
  },
  {
    fhir: [ 'extension', chapterExtension, 'valueString' ],
    form: [ 'chapter' ]
  },
  {
    fhir: [ 'onsetString' ],
    form: [ 'onsetComment' ]
  },
  {
    fhir: [ 'note', 0, 'text' ],
    form: [ 'comment' ]
  },
  {
    fhir: [ 'extension', primaryDiagnosisExtension, 'valueString' ],
    form: [ 'admitting' ],
    to_fhir: x => (x ? '1' : null),
    to_form: x => x === '1'
  },
  {
    fhir: [ 'extension', treatingPhysicianExtension, 'valueString' ],
    form: [ 'treatingPhysician' ]
  }
]

export const mapCondition = (patientId, form) => {
  const resource = transform(form, mapping, [ 'form', 'fhir' ])
  const patient = { reference: `Patient/${patientId}` }
  resource.subject = patient
  resource.dateRecorded = resource.dateRecorded || fhirDateTime(new Date())
  return resource
}

export const unmapCondition = data =>
  transform(data, mapping, [ 'fhir', 'form' ])
